import firebase from "firebase/app";
import "firebase/messaging";
import Repository from "@/repository";

export default {
  async created() {
    this.firebaseConnect();
  },
  methods: {
    async handlePush(pushData) {
      if (!pushData) {
        console.log("no pushData: " + pushData);
        return;
      }
      if (pushData.model === "Order") {
        if ("object" in pushData) {
          try {
            const order = JSON.parse(pushData.object);
            if (order?.id) {
              this.updateOrder(order);
              return;
            }
          } catch (e) {
            console.log("push object parse error");
          }
        }

        if ("object_id" in pushData) {
          const { value, error } = await Repository.Orders.getOne({
            id: pushData.object_id,
          });

          if (!error && value) {
            this.updateOrder(value);
          }
        }
      }
    },
    updateOrder(order) {
      this.$store.commit("orders/updateOrders", order);
    },
    async firebaseConnect() {
      if (firebase.messaging.isSupported()) {
        let firebaseConfig = {
          apiKey: "AIzaSyDSbuv8WatwTxRTy_3WzjelAWL5ulKcaH0",
          authDomain: "tire-calculator-52ebf.firebaseapp.com",
          projectId: "tire-calculator-52ebf",
          storageBucket: "tire-calculator-52ebf.firebasestorage.app",
          messagingSenderId: "311804994601",
          appId: "1:311804994601:web:a579e59d1361b498296838",
          measurementId: "G-JYLTGPH8EC",
        };
        let vapidKey =
          "BEzraF3JczP3-5CywVpVTIbJGXrh5V6kMYPjWGZSYoGydho2yt04NldhnQKL9RYL44GZi5jdtqidI_DrqlepkAA";

        if (!firebase.apps.length) {
          firebase.initializeApp(firebaseConfig);
          console.log("firebase initialize app");
        } else {
          console.log("firebase has app");
        }
        const messaging = firebase.messaging();
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            console.log("notification permission granted");

            messaging.getToken({ vapidKey }).then((token) => {
              const added = Repository.Fcm.addFCMToken({ token });
              if (!added) {
                alert(
                  "Не удалось добавить FCM ключ. Фоновое обновление заказов может не работать.",
                );
              } else {
                console.log("token: " + token);
              }
            });
          } else {
            alert(
              "Очень нужны права на отправку уведомлений. Без них не работает обновление заказов в фоне.",
            );
          }
        });
        messaging.onMessage((payload) => {
          setTimeout(() => {
            console.log(payload);
            this.handlePush(payload.data);
          }, 500);
        });

        navigator.serviceWorker.addEventListener("message", (payload) => {
          setTimeout(() => {
            console.log(payload);
            this.handlePush(payload.data.data);
          }, 500);
        });
      } else {
        console.log("firebase don*t supported");
      }
    },
  },
};
